module.exports = __webpack_public_path__ + "img/bg2.2dd2cb0c.jpg";